export interface AppConfig {
  BASE_URL: string;
  ANAGRAFICA_CREATE: string;
  ANAGRAFICA_EDIT: string;
}

let config: AppConfig | null = null;

export const loadConfig = async (): Promise<AppConfig | null> => {
  if (config) return config;

  // Prima prova a leggere da window.APP_CONFIG (caricato da config.js)
  if (window.APP_CONFIG) {
    config = {
      BASE_URL: window.APP_CONFIG.CLINWEB_BASE_URL || "",
      ANAGRAFICA_CREATE: "/clinweb2/checkin/anagrafica/nuova",
      ANAGRAFICA_EDIT: "/clinweb2/checkin/anagrafica/",
    };
    return config;
  }

  // Fallback: carica config.json
  try {
    const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
    if (response.ok) {
      config = await response.json();
      return config;
    }
  } catch {
    console.warn("config.json non trovato, uso valori da APP_CONFIG o default");
  }

  return config;
};

export const getConfig = (): AppConfig => {
  if (!config) {
    throw new Error("Config not loaded yet. Call loadConfig() first.");
  }
  return config;
};
